import axios, { AxiosResponse } from "axios";
import {
  ChangePasswordByEdsDto,
  ConfirmForgotPasswordCodeData,
  ConfirmPhoneData, DataFromEcp,
  ForgotPasswordCodeData,
  ILoginParams,
  SendPhoneConfirmKeyData
} from "./block-auth.type";
import { ILangValue} from "mixins/types";


/**
 * Выход из учетной записи по system ID provider
 */
export const login = (data: ILoginParams): Promise<AxiosResponse> => {
  return axios.post(`/admin/tool/_/idprovider/system`, data);
};

/**
 * Выход/регистраци по jwt ID provider
 */
export const auth = (data: ILoginParams): Promise<AxiosResponse> => {
  return axios.post(`/site/ru/master/isna-portal-cms/_/idprovider/jwt/login`, data);
};

/**
 * Выход из учетной записи по jwt ID provider
 */
export const logout = (): Promise<AxiosResponse> => {
  return axios.get(`/site/ru/master/isna-portal-cms/_/idprovider/jwt/logout`);
};

/**
 * Отправка кода подтверждения на email
 */
export const sendEmailConfirmKey = (email: string, lang: ILangValue): Promise<AxiosResponse> => {
  return axios.post(`/services/isnaportal/open-api/register/send-email-confirm-key`, {}, {
    params: { email, lang }
  });
};

/**
 * Подтверждение кода по email
 */
export const confirmEmail = (email: string, code: string): Promise<AxiosResponse> => {
  return axios.post(`/services/isnaportal/open-api/register/check-confirm-code`, {}, {
    params: { email, code }
  });
};

/**
 * Отправка кода подтверждения на телефон
 */
export const sendPhoneConfirmKey = (data: SendPhoneConfirmKeyData): Promise<AxiosResponse> => {
  return axios.post(`/services/isnaportal/open-api/register/send-phone-number-confirm-key`, data);
};

/**
 * Подтверждение кода по телефону
 */
export const confirmPhone = (data: ConfirmPhoneData): Promise<AxiosResponse> => {
  return axios.post(`/services/isnaportal/open-api/register/confirm-phone-number`, data);
};

/**
 * Восстановление пароля - код подтверждения
 */
export const sendForgotPasswordCode = (data: ForgotPasswordCodeData): Promise<AxiosResponse> => {
  return axios.post(`/services/isnaportal/open-api/register/forgot-password-notification`, data);
};

/**
 * Восстановление пароля - смена пароля
 */
export const restorePassword = (data: ConfirmForgotPasswordCodeData): Promise<AxiosResponse> => {
  return axios.post(`/services/isnaportal/open-api/register/change-password`, data);
};

/**
 * Получение данных из ЭЦП
 * @param data
 */
export const getDataFromEcp = (data: string): Promise<AxiosResponse<DataFromEcp>> => {
  return axios.post<DataFromEcp>(`/services/isnaportal/open-api/kalkan/validate`, data, {
    headers: {'Content-Type': 'text/plain'},
    responseType: 'text'
  });
};

/**
 * Смена пароля пользователя (после истечения его срока жизни)
 */
export const resetPassword = (data: ChangePasswordByEdsDto): Promise<AxiosResponse> => {
  return axios.post(`/services/isnaportal/open-api/register/change-password-by-eds`, data);
};

